import { useTranslation } from "react-i18next"
import { cn } from "@/lib/utils"
export interface FreeTextMedicationCreationProps extends React.HTMLAttributes<HTMLDivElement> {
  searchTerm: string
}

const FreeTextMedicationCreation = ({ searchTerm, className, ...props }: FreeTextMedicationCreationProps) => {
  const { t } = useTranslation()

  return (
    <div className={cn("cursor-pointer px-4 py-1", className)} {...props} data-testid="free-text-medication">
      <p className="text-primary text-sm" data-testid="free-text-medication-title">
        {t("patient.prescription.addFreeTextMedication.title", {
          searchTerm: `"${searchTerm}"`,
        })}
      </p>
      <p
        className="text-on-surface-subdued text-xs leading-4 tracking-[0.25px]"
        data-testid="free-text-medication-description">
        {t("patient.prescription.addFreeTextMedication.description")}
      </p>
    </div>
  )
}

export { FreeTextMedicationCreation }
